import { createContext } from "react";
var LoadingContext = createContext({
    isLoading: false,
    setIsLoading: function (value) { },
});
export default LoadingContext;
